import { create } from 'zustand';

const STORAGE_KEY = 'hakken-theme';

const getInitial = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {}
  // Default to dark (the city at night).
  return 'dark';
};

const applyTheme = (theme) => {
  const el = document.documentElement;
  el.classList.toggle('dark', theme === 'dark');
  el.classList.toggle('light', theme === 'light');
  el.style.colorScheme = theme;
};

const useThemeStore = create((set, get) => ({
  theme: getInitial(),
  setTheme: (theme) => {
    applyTheme(theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch {}
    set({ theme });
  },
  toggle: () => get().setTheme(get().theme === 'dark' ? 'light' : 'dark'),
}));

// Ensure the DOM matches the store on first load (in sync with the inline
// no-flash script in index.html).
applyTheme(useThemeStore.getState().theme);

export default useThemeStore;
